import { actionHandlerWithFeatureFlag } from 'utils';
import { FEATURE_FLAGS } from 'utils/constants';
import { msFetchSidemenuConfig } from 'services/ConfigService';
import SkRequest from './BaseRequest';
import { QueryBuilder } from '../queryBuilder';
import { FETCH_SIDEMENU_CONFIG } from './actionTypes';
import DatadogHandler from '../../utils/datadog';

const _mQueryBuilder = new QueryBuilder();

_mQueryBuilder.setNewQuery('findSidebarMenuByUser', {
  totalCount: 'number',
  data: {
    ID: 'number',
    icon: 'string',
    path: 'string',
    active: 'bool',
    label: 'string',
    fkNavigation: 'number',
  },
});

const dispatchSidemenu = (
  dispatch,
  inprogress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_SIDEMENU_CONFIG,
    key: 'sidemenu',
    value: {
      inprogress,
      data,
      error,
    },
  });
};

export const monoFetchSidemenuConfig = async (dispatch, reqBody) => {
  const { fkSchool } = reqBody;
  try {
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('findSidebarMenuByUser', {
          filter: {
            fkSchool,
          },
        }),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchSidemenuConfig',
        fileName: 'redux/actions/SidemenuConfig.js',
      },
      'error'
    );
    dispatchSidemenu(dispatch, false, null, { error: ex.message });
    return ex;
  }
};

export const fetchSidemenuConfig = fkSchool => async dispatch => {
  dispatchSidemenu(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msFetchSidemenuConfig,
      monoHandler: monoFetchSidemenuConfig,
      dispatch,
      extraData: { fkSchool },
    }
  );

  if (data.success) {
    dispatchSidemenu(dispatch, false, data);
  } else {
    dispatchSidemenu(dispatch, false, null, data.error);
  }
  return data;
};

export default fetchSidemenuConfig;
